import styled from '@emotion/styled'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AppointmentLengthOption } from '../../../__generated__/api'
import AppointmentLengthSelect from '../../../common/components/AppointmentLengthSelect/AppointmentLengthSelect'
import Modal from '../../../common/components/Modal/Modal'
import { Text } from '../../../common/components/Typography/Typography'
import { scale } from '../../../common/utils/scale'

const Heading = styled(Text)`
  margin-bottom: ${scale(4)};
`

interface Props {
  preselectedDuration: number
  preselectedServiceName: string
  availableDurations: number[]
  appointmentNotAvailableCallback(): void
  onClose(): void
  onSelect(duration: number): void
}

const SearchFlexiblePractitionerServiceSelect: React.FC<React.PropsWithChildren<Props>> = ({
  preselectedDuration,
  availableDurations,
  preselectedServiceName,
  appointmentNotAvailableCallback,
  onClose,
  onSelect,
}) => {
  const { t } = useTranslation()
  const [selectedDuration, setSelectedDuration] = useState<number>(preselectedDuration)

  const options: AppointmentLengthOption[] = availableDurations.map((duration) => ({
    duration,
    // Description array is not in use for flexible appointments
    description: [],
    serviceName: preselectedServiceName,
  }))

  useEffect(() => {
    if (!availableDurations.includes(preselectedDuration)) {
      appointmentNotAvailableCallback()
      return
    }
  }, [availableDurations, preselectedDuration, appointmentNotAvailableCallback])

  const radioLabelId = 'flexible-practitioner-service-select-radio'

  return (
    <Modal
      open={true}
      onClose={onClose}
      primaryButtonText={t('common.continue')}
      fullWidth={true}
      onPrimaryButtonClick={() => onSelect(selectedDuration)}
      secondaryButtonText={t('common.cancel')}
      onSecondaryButtonClick={onClose}
      autofocusFooterButton={true}
    >
      <Heading
        $size={450}
        $weight="Medium"
        $height="Medium"
        data-cy="practitionerFlexibleAppointmentLengthSelectModal-heading"
        id={radioLabelId}
      >
        {t('component.practitionerFlexibleAppointmentLengthSelectModal.header')}
      </Heading>
      <AppointmentLengthSelect
        options={options}
        value={selectedDuration}
        onSelect={(option) => setSelectedDuration(Number(option.duration))}
        radioLabelId={radioLabelId}
      />
    </Modal>
  )
}

export default SearchFlexiblePractitionerServiceSelect
